// extracted by mini-css-extract-plugin
export default {"page":"NotFoundPage_page__SPfCS","title":"NotFoundPage_title__3KCiL","text":"NotFoundPage_text__Bqdlj"};